var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordEMinor = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 26.04,
  d: "M302.74 467.35L104.31 126.03h394.64L302.74 467.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M362.85 475.73a61.64 61.64 0 11-61.64-61.63 61.64 61.64 0 0161.64 61.63z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  d: "M164.56 121.71a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#eada1b",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M309.33 476.87h-18.6v17.25h20.73v5.18h-26.91v-47.85h25.85v5.18h-19.67v15.13h18.6z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a6a8",
  stroke: "#00a6a8",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M119.38 141.54a45.57 45.57 0 01-15.06 2.7c-7.43 0-13.55-1.9-18.35-6.48-4.22-4.08-6.84-10.63-6.84-18.27.07-14.64 10.12-25.34 26.57-25.34a30.3 30.3 0 0112.23 2.26l-1.53 5.17a25.35 25.35 0 00-10.85-2.12c-11.94 0-19.73 7.43-19.73 19.73S93.32 139 104.75 139c4.15 0 7-.59 8.45-1.31v-14.64h-10V118h16.16z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#eada1b",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 3.25,
  d: "M225.84 297.74v-5.08c5.73-.19 9.8-1 12.21-2.34q5.58-3.13 5.57-11.73v-96.93q0-8.74-5.76-11.75-3.33-1.83-12-2.32v-5.09h115.3v40.36h-4.88q-3.81-19.35-12.95-26.48T290 169.25q-9.18 0-11.68 1.9t-2.49 7.58V225q17.1.19 23.16-6.2t9.28-23.41h5.08v67.62h-5.08q-2.11-17.01-8.7-24.01t-23.7-7v48.47q0 6.35 3.27 8.64c2.19 1.54 6.66 2.3 13.44 2.3q19.16 0 31.27-7.43t21.5-27.84h5.57l-8.11 41.62z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#eada1b",
  stroke: "#eada1b",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  d: "M349.2 213.4a6.19 6.19 0 002.94-.92q1.29-1 1.29-3.81v-23c0-1.65-.29-2.76-.87-3.35a5.82 5.82 0 00-3.36-1.19v-1.83H364v5.61a21.12 21.12 0 013.78-4 12.28 12.28 0 017.55-2.56c3.13 0 5.55.74 7.28 2.22a12 12 0 012.75 4.11h.53a21.15 21.15 0 014.24-4.08 11.88 11.88 0 017-2.25 11 11 0 017.26 2.63q3.15 2.64 3.15 8.32V209c0 1.81.29 3 .88 3.45a5.81 5.81 0 003.09 1v1.87H393v-1.92a5.94 5.94 0 003-1.05c.56-.5.84-1.62.84-3.38v-18.92a10.24 10.24 0 00-.89-4.72 3.52 3.52 0 00-3.42-1.68 6.76 6.76 0 00-4.25 1.85c-1.49 1.23-2.23 2.09-2.23 2.57V209c0 1.71.25 2.8.76 3.28a5.92 5.92 0 002.86 1.15v1.87h-18.35v-1.9a5.82 5.82 0 002.94-1c.58-.5.88-1.64.88-3.42v-18.93a10.84 10.84 0 00-.84-4.69c-.56-1.14-1.72-1.71-3.47-1.71a6.39 6.39 0 00-4.47 2c-1.37 1.31-2.05 2.13-2.05 2.46V209c0 1.71.24 2.8.72 3.28a5.7 5.7 0 002.86 1.15v1.87H349.2z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  d: "M558.71 118.07a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M484.73 94.48a63.13 63.13 0 0111.63-1c6.37 0 10.47 1.08 13.54 3.54a10.17 10.17 0 014.1 8.6c0 4.7-3.15 8.81-8.34 10.69v.15c4.68 1.15 10.17 5 10.17 12.21a13 13 0 01-4.17 9.75c-3.44 3.11-9 4.55-17.05 4.55a75.11 75.11 0 01-9.88-.58zm6.37 19.94h5.78c6.73 0 10.68-3.46 10.68-8.16 0-5.71-4.39-8-10.83-8a27.14 27.14 0 00-5.63.44zm0 23.34a34 34 0 005.34.29c6.58 0 12.66-2.38 12.66-9.47 0-6.64-5.78-9.39-12.74-9.39h-5.26z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordEMinor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-e-minor.61005db3ea69f2e0e09d1a9193e53379.svg";